import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { Card, CardInner, CardTitle } from 'components/Card'
import { Spacer } from 'components/Utility'
import { SubCaution } from 'components/Typography'

type Props = {
  transferAmount: number
  transferFee: number
  finalTransferAmount: number
}

const TransferCard: FC<Props> = React.memo((props) => {
  const { transferAmount, transferFee, finalTransferAmount } = props
  return (
    <Card>
      <CardInner>
        <CardTitle title={'明細'} />
        <Spacer size={20} />
        <ul className={styles.transfer__list}>
          <li className={styles.transfer__list__item}>
            <span>現時点入金対象額</span>
            <span>{transferAmount.toLocaleString()}円</span>
          </li>
          <li className={styles.transfer__list__item}>
            <span>銀行振込手数料</span>
            <span>{transferFee.toLocaleString()}円</span>
          </li>
          <li className={styles.transfer__list__item}>
            <span>最終入金金額</span>
            <span>{finalTransferAmount.toLocaleString()}円</span>
          </li>
        </ul>
        <Spacer size={16} />
        <SubCaution
          caution={
            '※入金時には、決済代行サービスによる銀行振込手数料 450円と対象金額の0.25%を差し引いた金額を予めご設定頂いている銀行口座へ３営業日程度で入金致します。'
          }
        />
      </CardInner>
    </Card>
  )
})

export default TransferCard
